const menu = [
  {
    id: 0,
    nombre: "Intranet",
    ruta: "Aplicaciones"
  }
];

export default menu;
